import Button from '@shared/components/core/button/CoreButton';
import useLicenseKeySearch from '@shared/hooks/useLicenseKeySearch';
import { ICoreButtonProps } from '@shared/models/components/ICoreButtonProps';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LicenseKeyPurchaseDialog from './LicenseKeyPurchaseDialog';
import LicenseKeySelectDialog from './LicenseKeySelectDialog';

interface ILicenseKeySelectAccessProps extends Omit<ICoreButtonProps, 'onClick' | 'children'> {
    children?: never;
    onClick?: never;
    href?: never;
}

function LicenseKeySelectAccess({
    $color = 'accent',
    $size = 'small',
    startIcon = 'plusLight',
    ...restProps
}: ILicenseKeySelectAccessProps) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const { results, loadingData } = useLicenseKeySearch('available');

    const onClose = () => {
        setOpen(false);
    };

    return (
        <>
            <Button $color={$color} $size={$size} onClick={() => setOpen(true)} startIcon={startIcon} {...restProps}>
                {t('common:organization.create')}
            </Button>
            {results.length < 1 && !loadingData ? (
                <LicenseKeyPurchaseDialog open={open} onClose={onClose} />
            ) : (
                <LicenseKeySelectDialog
                    availableKeys={results}
                    loadingData={loadingData}
                    open={open}
                    onClose={onClose}
                />
            )}
        </>
    );
}

export default LicenseKeySelectAccess;
